export default "__VITE_ASSET__MyYsxqSN__"